module.exports = __webpack_public_path__ + "img/rar.20f61cfb.svg";